<template>
  <b-dropdown
    size="md"
    variant="link"
    toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
    no-caret
    right
    no-flip
    v-b-tooltip.hover.top="$t('TRANSLATOR.EDIT')"
  >
    <template v-slot:button-content>
      <i class="flaticon2-settings"></i>
    </template>
    <!--begin::Navigation-->
    <div class="navi navi-hover min-w-md-350px p-3">
      <b-dropdown-text tag="div" class="navi-item">
        <a class="navi-link" disabled>
          <!-- <span class="navi-icon">
            <i class="flaticon2-settings"></i>
          </span> -->
          <span class="navi-text">{{ $t('TRANSLATOR.CHANGE_STATUS_FOR_ENTIRE') }} <b>Conveyor {{ conveyorNumber }}</b> {{ $t('TRANSLATOR.NOW_ITS') }} {{ newstatus }}</span>
        </a>
      </b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-separator my-3"></b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-item">
        <a class="navi-link" style="cursor: pointer" @click="SaveAllData('green')">
          <span class="navi-icon">
            <i class="flaticon2-check-mark text-success"></i>
          </span>
          <span :class="[currentStatus == 'green' ? 'navi-text label-light-primary' : 'navi-text']">{{ $t('TRANSLATOR.JUST_CHANGED') }}</span>
          <span class="navi-link-badge">
            <span class="label label-light-success label-inline font-weight-bold">
              {{ $t('TRANSLATOR.GREEN') }}
            </span>
          </span>
        </a>
      </b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-item">
        <a class="navi-link" style="cursor: pointer" @click="SaveAllData('orange')">
          <span class="navi-icon">
            <i class="flaticon2-warning text-warning"></i>
          </span>
          <span :class="[currentStatus == 'orange' ? 'navi-text label-light-primary' : 'navi-text']">{{ $t('TRANSLATOR.BE_CAREFULL') }}</span>
          <span class="navi-link-badge">
            <span class="label label-light-warning label-inline font-weight-bold">
              {{ $t('TRANSLATOR.ORANGE') }}
            </span>
          </span>
        </a>
      </b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-item">
        <a class="navi-link" style="cursor: pointer" @click="SaveAllData('red')">
          <span class="navi-icon">
            <i class="flaticon-cancel text-danger"></i>
          </span>
          <span :class="[currentStatus == 'red' ? 'navi-text label-light-primary' : 'navi-text']">{{ $t('TRANSLATOR.MUST_CHANGE') }}</span>
          <span class="navi-link-badge">
            <span class="label label-light-danger label-inline font-weight-bold">
              {{ $t('TRANSLATOR.RED') }}
            </span>
          </span>
        </a>
      </b-dropdown-text>
        <b-alert :show="dismissCountDown" dismissible fade variant="success" class="mt-5" @dismissed="dismissCountDown = 0">
          Status updated successfully
        </b-alert>
    </div>
    <!--end::Navigation-->
  </b-dropdown>
</template>

<style lang="scss">
.custom-v-dropdown {
  &.dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  &.dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<script>
import axios from 'axios';
export default {
  props: ['conveyorNumber', 'companyId', 'lineNumber'],
  name: "dropdown-3",
  data() {
    return {
      submitted: false,
      newstatus: "unchanged",
      dismissSecs: 5,
      dismissCountDown: 0,
    };
  },
  components: {},
  mounted() {},
  methods: {
    // submit form handler
    submit: function (code) {
      this.oldStatus = this.currentStatus
      this.currentStatus = code
      this.newstatus = code;
      this.dismissCountDown = this.dismissSecs;
      this.submitted = true;
    },
    SaveAllData: function(code) {
        this.newstatus = code;
      // Execute Update Conveyor Status
      axios.post('line/updateConveyorStatus', {CompanyId: this.companyId, LineNumber: this.lineNumber, ConveyorNumber: this.conveyorNumber, NewStatus: this.newstatus})
      .then(() => {
        // Reload page with new status
        this.$emit('statusChange')
        this.oldStatus = this.currentStatus
        this.currentStatus = code
        this.dismissCountDown = this.dismissSecs;
        this.submitted = true;
      }).catch(err => {
        throw err;
      })

    }
  }
};
</script>
